/**
 * This file contains all the config values that are used throughout the app.
 * It's a single source of truth for all the config values.
 *
 * It can also be used to mock the config values in tests.
 *
 * As you encounter import.meta.env used directly, declare a const here and move the value to it.
 */

export const API_HOSTNAME: string | undefined = import.meta.env.VITE_API_HOSTNAME
export const ADMIN_PANEL_URL: string = (API_HOSTNAME || '').replace(/\/$/, '').concat('/admin')
export const isDev: boolean = import.meta.env.MODE === 'development'
